module.exports = __webpack_public_path__ + "static/product-form-e3281a8144e7321cc33cdbfcde375436.png";